import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/img/MH3.9/notice.png")
    }
  }), _c('swiper', {
    staticClass: "text-scroll",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "auto": false,
      "direction": "vertical",
      "interval": 5000,
      "height": _vm.height,
      "show-dots": false
    }
  }, [_vm.noticeList.length === 0 ? _c('swiper-item', {
    staticClass: "banner-list"
  }, [_c('p', {
    staticClass: "content smy__text-overflow-one-line"
  }, [_vm._v(i18n.tc("41"))])]) : _vm._l(_vm.noticeList, function (item, index) {
    return _c('swiper-item', {
      key: index
    }, [_c('p', {
      staticClass: "content smy__text-overflow-one-line"
    }, [_vm._v(_vm._s(item.title))])]);
  })], 2), _c('img', {
    staticClass: "icons",
    attrs: {
      "src": require("@/assets/img/MH3.9/right-arrow.png")
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };